import { takeLatest, call, put, select } from 'redux-saga/effects';
import uuid from 'uuid';
import { API_LINK } from '../../constants';
import { xapiRequest, xapiSuccess, xapiFailure } from '../reducers/xapi';
import {selectedProgram, selectedProgramId, selectedContentId, selectedContent, selectedModule} from '../selectors'
import axios from 'axios';

import gql from 'graphql-tag';
import moment from 'moment';
const graphql = require('graphql');

const { print } = graphql;

const GRAPHQL_ENDPOINT = "https://6q4pq37mwrf6ffndyt4ucij4pm.appsync-api.us-east-1.amazonaws.com/graphql";
const GRAPHQL_API_KEY = "da2-zv4zsujr3jd2hhyg75i466buhu";
//const API = `https://wlndhhrq7ngovczqxasiyqkbna.appsync-api.us-east-1.amazonaws.com/graphql`;

function* xapiAxios() {
  const state = yield select(fullState => fullState);
  const { xapiType, type } = state.xapiReducer;


  
  const userReducer = state.loginReducer;
  const content = state.userProgramsFullReducer.item;
  let jsonPayload = null;


const createEngagement = gql`
mutation createEngagement($input: CreateEngagementInput!) {
       createEngagement(input: $input) {
        studentID
        idNumber
        email
        id
        type
        date
        time
        firstName
        lastName
        programName
        projectName
        rolloutName
        moduleName
        moduleStatus
        componentName
        componentStatus
        componentType
        user
        id
       }
   }
`
console.log('LOGGERx4 = ',content)
const user =  axios({
  url: GRAPHQL_ENDPOINT,
  method: 'post',
  headers: {
  'x-api-key':GRAPHQL_API_KEY
  },
  data:{
    query: print(createEngagement),
    variables: {
      input: {
      studentID: userReducer.user.userId,
      idNumber: userReducer.user.identityNo,
      email: userReducer.user.email,
      type: xapiType,
      date: new Date().toISOString().split('T')[0],
      time: new Date().toISOString().split('T')[1].split('.')[0],
      firstName: userReducer.user.firstName && userReducer.user.firstName,
      lastName: userReducer.user.lastName &&  userReducer.user.lastName,
      programName: selectedProgram(state) && selectedProgram(state).name+" ("+selectedProgram(state).programCode+")",
      projectName:selectedProgram(state) && selectedProgram(state).projectName+" ("+selectedProgram(state).projectCode+")",
      rolloutName: content && content.rolloutName,
      moduleName: content && content.moduleName+" ("+content.moduleCode+")",
      moduleStatus: selectedModule(state) && selectedModule(state).status,
      componentName:content && content.name+" ("+content.libraryCode+")",
      componentStatus: content && content.status,
      componentType: content && content.type,
      user: "Design",
      id: moment().format('YYYYMMDDHHMMSS')  + uuid.v4()
    }
  }
  }
})
  console.log('LOGGERx4 = ', user)
  return user
}

function* workerXapiSaga() {
  try {
    const response = yield call(xapiAxios);
    const responseData = response.data;

    if (response.status === 200) {
      yield put(xapiSuccess(responseData));
    }
  } catch (error) {
    yield put(xapiFailure(error));
  }
}

export function* watcherXapiSaga() {
  yield takeLatest(xapiRequest().type, workerXapiSaga);
}
